import React from 'react';
import './CreateJobAdvanced.scss';
import { useModalContext } from '../ModalContext';
import {
  Card,
  CardHeader,
  CardContent,
  Autocomplete,
  TextField,
} from '@mui/material';
import { useJobsContext } from 'components/JobList';
import { jobTypeInfo } from './jobTypeInfo';

const JobTypeExtraInfo = () => {
  const { formState } = useModalContext();
  const extraInfo = jobTypeInfo[formState.values.jobType]?.extraInfo;
  if(extraInfo) {
    return extraInfo
  } else {
    return <></>
  }
}

const JobTypeDropdown = ({readonly, filterOptions, onChange, options, value}) => {
  const options2 = options.map(o => {
    const label = jobTypeInfo[o]?.label || o;
    return {label, value: o}
  })

  const handleChange = (e, newvalue) => {
    onChange(newvalue.value)
  }
  
  return <Autocomplete
          disableClearable
          disabled={readonly}
          filterOptions={filterOptions}
          freeSolo
          handleHomeEndKeys
          id="auto-job-type"
          onChange={handleChange}
          options={options2}
          renderInput={
            (params) =>

            <TextField
            {...params}
            fullWidth
            label="Job type"
            margin="dense"
            name="jobType"
            variant="outlined"
            />
          } 
          required
          selectOnFocus
          value={value}
        />
}

export const JobTypeCard = () => {
  const { formState, setFormState } = useModalContext();
  const { jobTypes, readonly } = useJobsContext();
  const typeOptions = [...new Set([...(jobTypes || []), ...Object.keys(jobTypeInfo)])].filter(Boolean);
  const onTypeChange = (newValue) => {
    setFormState({
      ...formState,
      values: {
        ...formState.values,
        jobType: newValue
      }
    });
  };

  return <Card >
    <CardHeader title='Template' />
    <CardContent>
      <JobTypeDropdown
        readonly={readonly}
        options={typeOptions}
        onChange={v => onTypeChange(v)}
        value={formState.values.jobType}
      />
      <JobTypeExtraInfo />
    </CardContent>
  </Card>
};
